var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoAasAcademyRgbW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 56.7",
    style: {
      enableBackground: "new 0 0 283.5 56.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#F6961D;}\r\n\t.st2{fill:#3FCAEA;}\r\n\t.st3{fill:#7B7CD5;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.2,28.9c0-8.8,6.3-13.2,12.1-13.2c4.5,0,7.1,2.4,7.5,3.4H87v-2.9h7.6v25.3H87v-2.9h-0.1 c-0.4,0.9-3,3.4-7.5,3.4C73.6,42.1,67.2,37.7,67.2,28.9z M80.9,35.3c3.3,0,6.3-2.3,6.3-6.4s-3-6.4-6.3-6.4c-3.2,0-6.2,2.3-6.2,6.4 C74.7,33,77.7,35.3,80.9,35.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,28.9c0-8.6,6.7-13.1,13.5-13.1c4.5,0,8.4,2,10.9,6.2l-5.5,3.6c-1.2-1.7-3-3-5.5-3c-3.3,0-6,2.4-6,6.3 s2.8,6.4,6,6.4c2.4,0,4.2-1.3,5.5-3l5.5,3.6c-2.5,4.1-6.4,6.2-10.9,6.2C104.6,42.1,97.9,37.5,97.9,28.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.7,28.9c0-8.8,6.3-13.2,12.1-13.2c4.5,0,7.1,2.4,7.5,3.4h0.1v-2.9h7.6v25.3h-7.6v-2.9h-0.1 c-0.4,0.9-3,3.4-7.5,3.4C130.1,42.1,123.7,37.7,123.7,28.9z M137.4,35.3c3.3,0,6.3-2.3,6.3-6.4s-3-6.4-6.3-6.4 c-3.2,0-6.2,2.3-6.2,6.4S134.2,35.3,137.4,35.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.1,41.6v-2.9H174c-0.4,0.9-3,3.4-7.5,3.4c-5.7,0-12.1-4.3-12.1-13.2s6.3-13.2,12.1-13.2 c4.5,0,7.1,2.4,7.5,3.4h0.1V7h7.6v34.6H174.1z M168,35.3c3.3,0,6.3-2.3,6.3-6.4s-3-6.4-6.3-6.4c-3.2,0-6.2,2.3-6.2,6.4 S164.8,35.3,168,35.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M185,29c0-8.6,6.4-13.2,12.9-13.2c6.4,0,14,4.5,12.4,16.1h-18c1,2.7,3.6,4.1,6.9,4.1c2.2,0,4.2-0.5,6.1-1.9 l3.4,3.6c-2.1,2.6-5.7,4.5-10.3,4.5C191.4,42.1,185,37.3,185,29z M203.7,26.4c-0.5-2.9-3.1-4.3-5.7-4.3c-2.5,0-5.1,1.3-5.9,4.3 C192.1,26.4,203.7,26.4,203.7,26.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.8,27.2c0-3.2-1.8-4.8-4-4.8c-2.4,0-4.3,1.6-4.3,4.8v14.3h-7.6V16.2h7.6v3.1c1.4-2.1,3.7-3.6,7.1-3.6 c3,0,5.6,1.3,7.2,4c1.6-2.3,4.3-4,8.3-4c5.4,0,9.3,3.4,9.3,11.2v14.6h-7.6V27.2c0-3.2-1.8-4.8-4-4.8c-2.4,0-4.3,1.6-4.3,4.8v14.3 h-7.6L229.8,27.2L229.8,27.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.2,41.3l-10.5-25h7.7l6.4,16.5l6.4-16.5h7.7l-10.6,25.3l-3.9,9.3H260L264.2,41.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.3,18.4l-20.8-12c-8.4-4.9-19,1.2-19,11v24.1c0,9.7,10.5,15.8,19,11l20.8-12C62.7,35.4,62.7,23.3,54.3,18.4z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.1,44H3.3l4.8-3.3c0.6-0.4,0.6-1.1,0.1-1.6c-5.1-4.4-7.7-10.9-7-17.6c0.9-9.9,9.2-17.9,19.2-18.4 C32.8,2.3,43.1,12.8,42,25.3C41.1,35.6,31.5,44,21.1,44z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.7,5.2c-7.8-2.3-16.2,3.5-16.2,12.2v24.1c0,0.9,0.1,1.8,0.3,2.6h6.8c11.3,0,20.5-9.2,20.5-20.5 C42.1,15.5,37.4,8.5,30.7,5.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.1,22.5h2.3l5.1,12.2h-2.3l-1-2.4h-5.9c-0.4,0.9-0.7,1.7-1,2.4H21L26.1,22.5z M29.5,30.6L27.2,25 c-0.6,1.6-1.5,3.6-2.3,5.6H29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.6,22.5h2.3L44,34.7h-2.3l-1-2.4h-5.9c-0.4,0.9-0.5,1.7-0.7,2.4l-1.3-3L36.6,22.5z M40,30.6L37.7,25 c-0.6,1.6-1.5,3.6-2.3,5.6H40z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47,27.3c-1.7-0.2-2.6-0.9-2.6-1.8c0-0.8,0.8-1.3,2.1-1.3c1.6,0,3.3,0.7,4.4,1.8l-0.1-2.3 c-0.9-0.9-2.5-1.4-4.3-1.4c-2.6,0-4.5,1.4-4.5,3.5c0,2,1.6,3.3,4.4,3.7c2,0.2,2.8,1,2.8,1.9c0,1-0.7,1.6-2.3,1.6 c-1.3,0-2.6-0.4-3.6-1.1l1.1,2.6c0.7,0.2,1.5,0.3,2.5,0.3c3,0,4.9-1.4,4.9-3.5S50,27.7,47,27.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAasAcademyRgbW);
export default __webpack_public_path__ + "static/media/logo_AAS_academy_RGB_W.3e1583313f8d5f5f7d2002a41dc3af6f.svg";
export { ForwardRef as ReactComponent };